import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const responseParser = (data: any) => {
  if (isStatusOK(data)) {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

const getCheckStatusRequest = (idempotentKey: string) => {
  return {
    transaction: {
      idempotentKey,
      method: {
        type: 425,
        subType: 612,
      },
    },
  }
}

export const checkRemittanceStatus = (tokens: any, idempotentKey: any) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  const request: Request<{}> = {
    apiPath: APIEndPoints.validateBenifStatus,
    method: 'POST',
    config: config,
    body: getCheckStatusRequest(idempotentKey),
  }
  sendEventApi(tokens, request, {
    status: 'INIITATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
